import * as React from 'react';
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../../../components/shared/hoc/createResidentWithErrorHandlingPage';
import {ReactElement} from 'react';
import {StyledPageTitle} from '../../../components/reservations/components/CommonStyle';
import {
    DisplayItemDividerForPageTop
} from '../../../styledComponents/DisplayItem';
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience';
import NatResidentDisasterTopicForm from './resident/NatResidentDisasterTopicForm';
import {PlainLinkStyledBackButton, StyledSecondaryButton} from '../../../styledComponents/Button';
import {
    NatPostDisasterTopicRegisterResult,
    NatPostDisasterTopicRegisterRequest,
} from './repository/NatPostDisasterTopicRegister';
import styled from 'styled-components'
import {Messages} from '../../../Messages';
import {MESSAGE_TYPE} from '../../../CodeMaster';
import NatResidentMessageDialogComponent from '../common/resident/NatResidentMessageDialogComponent';
import NatDisasterRepo from './repository/NatDisasterRepo';
import {Nullable} from '../../../app/TypeHelpers';
import {
    HeadingAreaMessageComponentForResident
} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponentForResident';

interface Props {
    condominiumCd: string,
    disasterRepo: NatDisasterRepo,
}

interface State {
    openChangeDialog: boolean,
    request: Nullable<NatPostDisasterTopicRegisterRequest>
}

class NatResidentDisasterTopicRegisterPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet, State> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.state = {
            openChangeDialog: false,
            request: null,
        }

        this.handleBackLinkOnClick = this.handleBackLinkOnClick.bind(this)
        this.onClickRegisterButton = this.onClickRegisterButton.bind(this)
        this.handleCancelClick = this.handleCancelClick.bind(this)
        this.handleDialogOkClick = this.handleDialogOkClick.bind(this)
    }

    handleBackLinkOnClick(): void {
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/disasters/topics`
        )
    }

    onClickRegisterButton(request: NatPostDisasterTopicRegisterRequest): void {
        this.setState({
            openChangeDialog: true,
            request: request
        })
    }

    handleCancelClick(): void {
        this.setState({openChangeDialog: false})
    }

    async handleDialogOkClick(): Promise<void> {
        const {eventEmitter, disasterRepo, condominiumCd} = this.props
        const {request} = this.state
        this.setState({openChangeDialog: false})
        await this.props.eventEmitter.showLoading()
        try {
            if (request != null) {
                const response: Nullable<NatPostDisasterTopicRegisterResult> = await this.props.asyncCallFunction(
                    this.props.disasterRepo.registerDisasterTopicResident.bind(disasterRepo, condominiumCd, request),
                    (httpErrorOrNetworkError) => {
                        httpErrorOrNetworkError.broadcast(eventEmitter)
                    },
                    {
                        defaultErrorTitle: Messages.EOPCR0014.toString(),
                        defaultErrorTitlePriority: true
                    },
                )
                if (response && response.details && response.requestError === null) {
                    this.props.navigate(
                        `/resident/condominiums/${condominiumCd}/disasters/topics/${response.details.topicId}`,
                        {replace: true}
                    )
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    renderDisasterTopicRegisterDialog(): ReactElement {
        const message: string = Messages.IOPCC0012.toString('トピック')

        return (
            <NatResidentMessageDialogComponent
                open={this.state.openChangeDialog}
                params={{
                    title: '確認',
                    errorLevel: MESSAGE_TYPE.WARNING,
                    message: message,
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.handleCancelClick,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleDialogOkClick,
                        },
                    ],
                }}
            />
        )
    }

    render(): ReactElement {
        return (
            <>
                {this.renderDisasterTopicRegisterDialog()}
                <PlainLinkStyledBackButton onClick={this.handleBackLinkOnClick}>
                    戻る
                </PlainLinkStyledBackButton>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <StyledPageTitle>トピック登録</StyledPageTitle>
                <BlockSpacer height={'20px'}/>
                <HeadingAreaMessageComponentForResident eventEmitter={this.props.eventEmitter}/>
                <NatResidentDisasterTopicForm
                    {...this.props}
                    {...this.state}
                    submitButtonLabel={'登録する'}
                    onClickRegisterButton={this.onClickRegisterButton}
                />
                <BackButton onClick={this.handleBackLinkOnClick}>
                    戻る
                </BackButton>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentDisasterTopicRegisterPage)

const BackButton = styled(StyledSecondaryButton)`
    margin-top: 30px;
    margin-bottom: 15px;
`